"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var date_fns_1 = require("date-fns");

var lodash_1 = require("lodash");

var ADDRESS_TYPES = __importStar(require("./types"));

function sortFillAddressesDates() {
  var dirtyAddresses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  // Sort before mapping so we can set end dates easily
  var sortedAddresses = (0, lodash_1.orderBy)(dirtyAddresses.filter(function (add) {
    return add != null && add.type !== ADDRESS_TYPES.MAILING;
  }), ["startedAt", "endedAt"], ["desc", "desc"]); // Map

  return sortedAddresses.map(function (address, index, array) {
    // If we have dates, don't do anything
    if ((0, date_fns_1.isValid)(new Date(address.startedAt)) && (0, date_fns_1.isValid)(new Date(address.endedAt))) return address; // If it's the first item and no end date, add endDate

    if (index === 0 && (!address.endedAt || !(0, date_fns_1.isValid)(new Date(address.endedAt)))) {
      return _objectSpread(_objectSpread({}, address), {}, {
        endedAt: (0, date_fns_1.format)(new Date(), "yyyy-MM-dd")
      });
    } // If missing an end date should pull from more recent start date


    if (address.endedAt == null && array[index - 1]) {
      return _objectSpread(_objectSpread({}, address), {}, {
        endedAt: array[index - 1].startedAt
      });
    } // TODO: Handle missing start dates


    return address;
  });
}

exports.default = sortFillAddressesDates;